@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"); 
/* @import "~@fortawesome/fontawesome-free/css/all.css";  */
@import url("https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.2/css/all.min.css"); 
/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */
:host {
  display: block;
}
